import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

export default hyperdbTriggers({ config,
  namespace: 'ZONE',
  entryPoint: '/zones',
  collectionName: 'zones',
  querySearchListing: [
    ['name', ['country', ['name'] ]],
    { order: { id: 'asc' } }
  ],
  successMessageCreate: 'Zone created',
  successMessageUpdate: 'Zone updated',
  successMessageDelete: 'Zone deleted',
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/zone/triggers.js